import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/Tools.css';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

function LoginPrompt({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const submit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API}/auth/login`, { password });
      localStorage.setItem('token', res.data.token);
      onLogin(res.data.token);
    } catch { setError('密码错误'); }
  };
  return (
    <div className="tools-login">
      <form onSubmit={submit}>
        <h2>Tools</h2>
        <input type="password" placeholder="密码" value={password}
          onChange={e => setPassword(e.target.value)} autoFocus />
        {error && <p className="tools-login-error">{error}</p>}
        <button type="submit" className="btn btn-primary">进入</button>
      </form>
    </div>
  );
}

const TOOLS = [
  {
    path: '/sb',
    code: 'SB',
    title: '番茄钟',
    desc: '专注计时 · 任务看板 · 历史统计',
  },
  {
    path: '/sticker',
    code: 'ST',
    title: '便签墙',
    desc: '自由拖拽的彩色便签笔记',
  },
  {
    path: '/ha',
    code: 'HA',
    title: '习惯追踪',
    desc: '每日习惯网格 · 时间序列可视化',
  },
  {
    path: '/cook',
    code: 'CK',
    title: '菜谱',
    desc: '食材库 · 菜谱卡片 · 今天能做什么',
  },
  {
    path: '/todo',
    code: 'TD',
    title: 'TODO',
    desc: '砖墙便签板 · 撕下贴墙 · 揉成纸团扔掉',
  },
  {
    path: '/table',
    code: 'TB',
    title: 'Table',
    desc: '纯文字表格 · 拖选几格直接贴进 Excel',
  },
  {
    // Mounted server-side at /mnemos (separate Hono app bridged into this
    // Express server, see server/server.js) — not a client-side route,
    // so this stays a real <a> nav rather than a react-router <Link>.
    external: true,
    url: '/mnemos',
    code: 'MN',
    title: 'Mnemos',
    desc: '按日期流动的研究笔记 · 任务归类 · 截图即传',
  },
];

export default function Tools() {
  const [token, setToken] = useState(() => localStorage.getItem('token'));
  if (!token) return <LoginPrompt onLogin={setToken} />;
  return (
    <div className="tools-page">
      <header className="tools-header">
        <h1>Tools</h1>
        <p className="tools-subtitle">私人工具集</p>
      </header>
      <div className="tools-grid">
        {TOOLS.map(t => {
          const card = (
            <>
              <div className="tool-card-code">{t.code}</div>
              <h3 className="tool-card-title">{t.title}</h3>
              <p className="tool-card-desc">{t.desc}</p>
              <span className="tool-card-arrow">{t.external ? '↗' : '→'}</span>
            </>
          );
          return t.external ? (
            <a key={t.url} href={t.url} target="_blank" rel="noopener noreferrer" className="tool-card">
              {card}
            </a>
          ) : (
            <Link key={t.path} to={t.path} className="tool-card">
              {card}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
